import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { appendQueryParamIfNotEmpty, formatDate } from '../../../constants/hookConstants';
import { handleApiError } from '../../requestHelpers/requestHelpers';
import { ManualSyncDateRangeParams } from './useSyncOrganizationByDateRange';

export const useClearFormSubmissionIndex = () => {
  const { t } = useTranslation();

  return useMutation(
    ({ from, to }: ManualSyncDateRangeParams) => {
      const queryParams = new URLSearchParams();
      appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
      appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));

      return dataFetch.delete(
        `${CORE_API_SUFFIX}form-submission/index/clear?${queryParams.toString()}`,
      );
    },
    {
      onSuccess: () => {
        closableEnqueueSnackbar(t('clearFormSubmissionIndexSuccess'), 'success');
      },
      onError: (error: any) => {
        handleApiError(error, t);
      },
    },
  );
};
